import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo, Brand, BrandText } from "@/components/Logo";
import { ArrowLeft, Sparkles } from "lucide-react";

const PARAGRAPHS = [
  "We are Reggie and Charen Smith the owners and creators of aiBLACK.",
  "aiBLACK is designed to be your source of Useful Personal and Business Information and your Daily Assistant.",
  "aiBLACK is an important AI Tool for Your Life, but AI should never replace safety and critical thinking, aiBLACK will only compliment your abilities.",
  "We have drawn on our lifetime of experience as a Proud, Educated Black Parents in America to self-learn coding and Develop the aiBLACK platform.",
  "We envision aiBLACK as a living breathing extension of The Black Experience in cyberspace.",
  "With our database of Black Knowledge, Black Information and Black Empowerment aiBLACK responses are written with Black-community context, examples, and voices front and center.",
  "aiBLACK is designed to listen and grow along with the input and knowledge from Our Black Community.",
  "Our life's journey has Blessed us with Family, Moral and Social skills, as well as Religious, Musical, Political and Business skills from these Experiences.",
  "Now we want to share Wisdom and Self Empowerment to Our Black Community through aiBLACK.",
];

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <header className="sticky top-0 z-20 backdrop-blur-xl bg-[#0a0a0f]/80 border-b border-[#2a3040]"
        style={{ paddingTop: "env(safe-area-inset-top)" }}>
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <button data-testid="about-back-button" onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm text-[#9ca3af] hover:text-white transition-colors">
            <ArrowLeft size={18} /> Back
          </button>
          <Logo size="text-xl" />
        </div>
      </header>

      <motion.main initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto px-5 py-12" data-testid="about-page">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#FF5A00] font-bold mb-3">
          <Sparkles size={14} /> Our Story
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-[1.05] mb-3">
          A Note from Reggie and Charen Smith,<br />
          <span className="text-[#FF5A00]">founders of <Brand /></span>
        </h1>
        <p className="text-[#9ca3af] text-lg mb-10">Meet the creators behind <Brand /> and the vision that shaped it.</p>

        <div className="relative bg-[#15151d] border border-[#2a3040] rounded-2xl p-7 sm:p-10 overflow-hidden">
          <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-[#FF5A00]/15 blur-3xl pointer-events-none" />
          <img src="/reggie.jpg" alt="Reggie and Charen Smith, founders of aiBLACK" data-testid="about-founder-photo"
            className="float-right ml-4 mb-3 w-24 h-24 rounded-xl object-cover border-2 border-[#FF5A00]/50 shadow-lg" />
          <p className="text-white text-xl font-display font-bold mb-6">Hello,</p>
          <div className="space-y-5 text-[#c7ccd6] leading-relaxed text-[16px]">
            {PARAGRAPHS.map((p, i) => (
              <p key={i}><BrandText>{p}</BrandText></p>
            ))}
          </div>
          <div className="mt-8 pt-6 border-t border-[#2a3040]">
            <p className="text-[#9ca3af]">Thank You</p>
            <p className="font-display font-black text-2xl text-white mt-1">Reggie and Charen Smith</p>
            <p className="text-xs uppercase tracking-[0.2em] text-[#FF5A00] font-bold mt-1">Founders & Creators, <Brand /></p>
          </div>
        </div>
      </motion.main>
    </div>
  );
}
